export default __webpack_public_path__ + "static/media/6.489cd37a.jpg";